import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InvoicesService{
    constructor(private http:HttpClient){}
    createInvoice(body: any){
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        
        let url = environment.auth_url+"/api/createInvoice";
        return this.http.post<any>(url, body);
    }
    getAllInvoices(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllInvoices";
        return this.http.post<any>(url, body, { headers });
    }
    getAllInvoicesByPoId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getInvoicesByPoId";
        return this.http.post<any>(url, body, { headers });
    }

    getAllInvoicesByUserIdPoId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getInvoicesByUserIdPoId";
        return this.http.post<any>(url, body, { headers });
    }



    getInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getInvoiceDataById";
        return this.http.post<any>(url, body, { headers });
    }
    getReviewerInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getReviewerInvoiceDataById";
        return this.http.post<any>(url, body, { headers });
    }
    saveInvoiceItemDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/saveInvoiceItemDataById";
        return this.http.post<any>(url, body, { headers });
    }
    reviewInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/reviewInvoiceDataById";
        return this.http.post<any>(url, body, { headers });
    }
    rejectInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/rejectInvoiceDataById";
        return this.http.post<any>(url, body, { headers });
    }
    reviewInvoiceDataByReviewerId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/reviewInvoiceDataByReviewerId";
        return this.http.post<any>(url, body, { headers });
    }
    rejectInvoiceDataByReviewerId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/rejectInvoiceDataByReviewerId";
        return this.http.post<any>(url, body, { headers });
    }
    holdInvoiceDataByReviewerId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/holdInvoiceDataByReviewerId";
        return this.http.post<any>(url, body, { headers });
    }
    deleteInvoiceDataByReviewerId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/deleteInvoiceDataByReviewerId";
        return this.http.post<any>(url, body, { headers });
    }
    exportInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/exportInvoiceDataById";
        return this.http.post<any>(url, body, { headers, responseType: 'blob' as 'json' });
    }

    exportConsolidatedInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/exportConsolidatedInvoiceDataById";
        return this.http.post<any>(url, body, { headers, responseType: 'blob' as 'json' });
    }


    deleteInvoiceDataById(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/deleteInvoiceDataById";
        return this.http.post<any>(url, body, { headers });
    }

    getAllNewInvoicesByReviewer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllNewInvoicesByReviewer";
        return this.http.post<any>(url, body, { headers });
    }

    getAllReviewedInvoicesByReviewer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllReviewedInvoicesByReviewer";
        return this.http.post<any>(url, body, { headers });
    }
    
    getAllRejectedInvoicesByReviewer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllRejectedInvoicesByReviewer";
        return this.http.post<any>(url, body, { headers });
    }

    createCustomerInvoice(body: any){
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        
        let url = environment.auth_url+"/api/createCustomerInvoice";
        return this.http.post<any>(url, body);
    }

    getAllNewInvoicesByCustomer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllNewInvoicesByCustomer";
        return this.http.post<any>(url, body, { headers });
    }

    getAllReviewedInvoicesByCustomer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllReviewedInvoicesByCustomer";
        return this.http.post<any>(url, body, { headers });
    }

    getAllRejectedInvoicesByCustomer(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getAllRejectedInvoicesByCustomer";
        return this.http.post<any>(url, body, { headers });
    }

    saveNotesByWorkspaceIdInvoiceId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/saveNotesByWorkspaceIdInvoiceId";
        return this.http.post<any>(url, body, { headers });
    }

    saveNotesByWorkspaceIdReviewerInvoiceId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/saveNotesByWorkspaceIdReviewerInvoiceId";
        return this.http.post<any>(url, body, { headers });
    }
    saveInvoiceConfigDetails(body: any){
        // const headers = {
        //     'Content-Type': 'application/json'
        // };
        // let url = environment.auth_url+"/api/saveInvoiceConfigDetails";
        // return this.http.post<any>(url, body, { headers });
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        
        let url = environment.auth_url+"/api/saveInvoiceConfigDetails";
        return this.http.post<any>(url, body);
    }
    validateInvoiceConfigDetails(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/validateInvoiceConfigDetails";
        return this.http.post<any>(url, body, { headers });
    }

    saveCoordinateConfigDetails(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/saveCoordinateConfigDetails";
        return this.http.post<any>(url, body, { headers });
    }
    downloadInvoiceById(body: any){
        let url = environment.auth_url+"/api/downloadInvoiceByUserAndId/"+body.userId+"/"+body.invoiceId;
        return url;
    }

    getInvoiceSheetPreview(userId: string | number, invoiceId: string | number){
        const url = environment.auth_url + '/api/getInvoiceSheetPreview/' + userId + '/' + invoiceId;
        return this.http.get<any>(url);
    }

    getPendingStoreAssignment(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        const url = environment.auth_url + '/api/getPendingStoreAssignmentByAdmin';
        return this.http.post<any>(url, body, { headers });
    }

    reassignInvoiceStore(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        const url = environment.auth_url + '/api/reassignInvoiceStoreByAdmin';
        return this.http.post<any>(url, body, { headers });
    }

}